import { Typography } from '@mui/material'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { Offcanvas } from '@/entities/offcanvas'
import { EditSchoolForm } from '@/features/edit-school-form'
import { useSchoolItem } from '@/shared/api/school'
import { useRouteOffcanvas } from '@/shared/hooks/use-route-offcanvas'
import { OffcanvasSkeleton } from '@/shared/ui/offcanvas-skeleton'

export const Route = createFileRoute(
  '/_auth/administration/reference-books/schools/update/$schoolId'
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { schoolId } = Route.useParams()
  const { data: school, isLoading, isError } = useSchoolItem({ id: schoolId })
  const { t } = useTranslation()

  const { isOpen, close } = useRouteOffcanvas('../..')

  return (
    <Offcanvas open={isOpen} onClose={close} title={t('Редактирование записи школы')}>
      {isLoading && <OffcanvasSkeleton />}
      {isError && (
        <Typography color="error">{t('Техническая ошибка. Повторите попытку позже')}</Typography>
      )}
      {school?.school && <EditSchoolForm school={school.school} onClose={close} />}
    </Offcanvas>
  )
}
